





















































































































































import { Vue, Component } from 'vue-property-decorator';
import { mdbAlert, mdbTooltip, mdbBtn, mdbRow, mdbCol, mdbInput, mdbSelect, mdbIcon, mdbCard, mdbCardImage, mdbView, mdbMask, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText } from '@folky-tools/mdbvue';
import {
    businessFrontPagesService,
    notificationsService,
    usersService,
    updateBusinessFrontPageClaimsAndMainImageService,
    UpdateBusinessFrontPageClaimsAndMainImageInputDto,
    updateBusinessFrontPageClaims,
    UpdateBusinessFrontPageClaimsInputDto
} from '@/services';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';

@Component({
    components: {
        mdbAlert,
        mdbTooltip,
        mdbBtn,
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbIcon,
        mdbCard,
        mdbCardImage,
        mdbView,
        mdbMask,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        FileUpload: () => import('@/components/shared/FileUpload.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class EditBusinessImageAndTitlesView extends Vue {
    private businessFrontPage: BusinessFrontPage = new BusinessFrontPage();
    private isSavingData: boolean = false;
    private mainImage: File | null = null;
    private showEditImage: boolean = false;
    private changingImage: boolean = false;

    private async created(): Promise<void> {
        this.businessFrontPage = await businessFrontPagesService.getBusinessFrontPage(+this.$route.params.id);
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.editBusinessImageAndTitlesView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');
    }

    private editImage() {
        this.showEditImage = true;
    }

    private async changeImage(): Promise<void> {
        this.changingImage = true;
        try {
            const image: File = (this.$refs.editImage as any).getFinalImageFile();
            if (image) {
                this.mainImage = image;
            }
            this.showEditImage = false;
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.changingImage = false;
        }
    }

    private async closeEditImage(): Promise<void> {
        const frontPage = await businessFrontPagesService.getBusinessFrontPage(+this.$route.params.id);
        this.businessFrontPage.mainImageUrl = frontPage.mainImageUrl;
        this.showEditImage = false;
    }

    private removeImage() {
        this.businessFrontPage.mainImageUrl = '';
        this.mainImage = null;
    }

    private async saveChanges(): Promise<void> {
        this.isSavingData = true;
        try {
            if (this.mainImage || !this.businessFrontPage.mainImageUrl) {
                await updateBusinessFrontPageClaimsAndMainImageService.execute(new UpdateBusinessFrontPageClaimsAndMainImageInputDto(this.businessFrontPage.businessId, this.businessFrontPage.claim, this.businessFrontPage.subclaim, this.mainImage));
            } else {
                await updateBusinessFrontPageClaims.execute(new UpdateBusinessFrontPageClaimsInputDto(this.businessFrontPage.businessId, this.businessFrontPage.claim, this.businessFrontPage.subclaim));
            }
            notificationsService.showToastSuccessNotification('views.businesses.businessFrontPageView.notifications.imageAndTitlesUpdated');

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasChanged,
                    entity: UserActionEntityType.Businesses,
                    scope: UserActionScopeType.Titles,
                    entityId: +this.$route.params.id
                })
            );
            this.$router.back();
            return;
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.isSavingData = false;
        }
    }
}
